<template>
  <div>
    <div class="Investment-box">
      <section class="permanently-close-acc">
        <div class="sidebar-container"></div>
        <div class="main-contents">
          <ul class="breadcrumbs-list">
            <a href="javascript:void(0)" @click="backButton"
              ><li>Value Added Services</li></a
            >
            <li>&nbsp;>&nbsp;My Will</li>
          </ul>
          <h2>
            <span style="color: #1a407d; font-size: 27px"> MY</span
            ><span style="color: #f19700; font-size: 18px; top: 12px">
              WILL</span
            >
          </h2>
        </div>
      </section>
    </div>
    <v-card>
      <div>
        <h3 style="text-align: center; color: #1a407d; padding: 20px">
          Charges for New WILL Creation
        </h3>
        <br />
        <div>
          <div v-for="val in item" v-bind:key="val">
          <v-row no-gutters>
            <v-col col-md-6 cols-6>
              <div class="will_container">{{val.will_type}}</div>
            </v-col>
            <v-col col-md-6 cols-6>
              <div class="payment-one" :style="'background:'+val.color">
                Rs. {{val.price_per_will}} <span style="font-size: 13px">per WILL</span>
              </div>
            </v-col>
          </v-row>
          <br />
          </div>

          <v-row>
            <v-col>
              <div class="charges">Charges for amendment of WILL is Rs 500</div>
            </v-col>
          </v-row>
          <div class="will-creation">
            <v-row>
              <v-col lg="6" md="12" cols="12">
                <div class="member-box">
                  <h2 class="head">Select Members</h2>
                  <div class="member-select" v-for="(item,index) in all_member_list" :key="item" >
                    <h2>Member {{index +1}}</h2>
                    <div class="member d-flex align-item-center">
                      <v-list-item-avatar :style="'background-color:' +item.color[index%3]">
                      <span class="user-nameshortbox"> </span>
                    </v-list-item-avatar>
                      <v-select 
                        v-model="item.selectedMember"
                        :items="item.members"
                        :error-messages="selectErrors"
                        required
                      >
                    </v-select>
                    </div>
                  </div>
                  <a  @click="addMembers" class="addMember">+ Add </a>
                  <a style="color:red; margin-left:65%;" v-if="this.count > 1" @click="remove(index)" class="addMember"> - Remove </a>
                </div>
              </v-col>
              <v-col lg="6" md="12" cols="12">
                <div class="paymentDetail">
                  <h2 class="head">Payment Details</h2>
                  <div
                    class="d-flex total-detail justify-space-between align-center"
                  >
                    <h2>Total Payment (incl GST)</h2>
                    <h2>Rs. {{totalPrice}}</h2>
                  </div>
                  <div class="payment-box">
                    <div class="d-flex justify-space-between align-center">
                      <h2 class="c-head">Enter Discount Coupon</h2>
                      <p class="c-pay">- Rs. {{discount}}</p>
                    </div>
                    <div
                      class="d-flex justify-space-between align-center input-box"
                    >
                      <v-text-field
                        v-model="coupon"
                        :items="discount"
                        class="form-field"
                        placeholder="NIMXX"
                        @input="change"
                      ></v-text-field>
                      <button class="pay-button" @click="addCoupon" :disabled="coupon ==''">Apply</button>
                    </div>
                    <p class="sub-title">
                      Enter coupon code to avail discount.
                    </p>
                  </div>
                  <p class="hor-line"></p>
                  <div class="payment-box">
                    <div class="d-flex justify-space-between align-center">
                      <h2 class="c-head">Redeem Points</h2>
                      <p class="c-pay">- Rs. {{use_reward}}</p>
                    </div>
                    <h2 class="sub-head">
                      You've {{reward}} points available for this purchase
                    </h2>
                    <div
                      class="d-flex justify-space-between align-center input-box"
                    >
                      <v-text-field
                       v-model="rewardPoint"
                         @input="changeReward"
                       class="form-field" 
                       placeholder="Reward Points" />
                      <button class="pay-button" @click="redeemedPoint">Redeem</button>
                    </div>
                    <p class="sub-title">
                     Enter number of points to redeem.
                    </p>
                    <span>(1 point = 1 Re)</span>
                  </div>
                  <div class="gst-box">
                    <div class="d-flex justify-space-between align-center">
                      <p>Net Payment (incl GST)</p>
                      <p>Rs. {{this.totalPrice - this.discount - this.use_reward}}</p>
                    </div>
                  </div>
                  <p class="content">
                    The above payment is the fee charged by Nimeya for
                    creation/amendment of Will document. The fee is inclusive of
                    any GST payment. Payment towards Will creation is
                    non-refundable.
                  </p>
                  <button class="will-button1" @click="nextPage">
                    PROCEED TO PAYMENT
                  </button>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-card>

    <v-dialog  content-class="modal-style" v-model="procced_dialog" persistent height="800px" max-width="892px"> 
      <v-card>
        <div class="payment-detail-page new-payment-design">
          <div>
            <h2>Choose your preferred mode of payment</h2>
            <v-card>
              <v-list-item>
                <v-list-item-content>
                  <p>Please select your convenient mode of payment</p>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-card @click="choosePaymentMethod('cashfree')">
                    <v-img
                      max-height="120"
                      max-width="120"
                      :src="cashfree_pic"
                      :lazy-src="cashfree_pic"
                    ></v-img>
                    <span>Internet banking/UPI's/Wallets/Cards</span>
                    <v-img
                      max-height="20"
                      max-width="20"
                      src="../../assets/images/right-arrow.png"
                    ></v-img>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-card @click="choosePaymentMethod('razorpay')">
                    <v-img
                      max-height="120"
                      max-width="120"
                      :src="razorpay_pic"
                      :lazy-src="razorpay_pic"
                    ></v-img>
                    <span>UPI's/Netbanking/Cards</span>
                    <v-img
                      max-height="20"
                      max-width="20"
                      src="../../assets/images/right-arrow.png"
                    ></v-img>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <p>
                    Receipt will be generated and will be sent to the registered email
                    provided.
                  </p>
                </v-list-item-content>
              </v-list-item>
              <v-list-item >
                <v-row class="buttonbox" style="border: none !important; background-color: #C7ECF8 !important;">
                  <v-btn class="blue-border-btn" style="background-color: #D9E6EA !important;" @click="procced_dialog=false"> Back </v-btn>
                  <!-- <v-btn class="blue-btn" @click="afterPayment"> Continue After Payment </v-btn> -->
                </v-row>
              </v-list-item>  
            </v-card>
            
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { GET_PROFILE_DETAIL, GET_REFERRAL_DETAIL } from "../../store/actions.type";

import { required, minLength, maxLength } from "vuelidate/lib/validators";
import axios from 'axios';
 import { Auth } from "aws-amplify";
export default {
  data: () => ({
    item:[],
    cashfree_pic: process.env.VUE_APP_ROOT_ICONS_URL + "cashfree.png",
    razorpay_pic: process.env.VUE_APP_ROOT_ICONS_URL + "razorpay.png",
    memberDetails: [],
    coupon:'',
    discount:0,
    member: [],
    selectedMembers: [],
    members_count:1,
    select: null,
    all_member_list:[],
    rewardPoint:'',
    procced_dialog:false,
    use_reward:0,
    myInterval:'',
    items:[],
    member_id:'',
    is_payment_confirmation:false,
    reward_point:[],
    reward:'',
    response:[],
    totalMembers:0,
    totalPrice:0,
    selectErrors:''
  }),
   computed: {
  
   },
  mounted() {
    Auth.currentAuthenticatedUser({
			bypassCache: false
		})
    .then(user => {	
			this.user_name = user.attributes["custom:name"];
			let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
			let formdata  = new FormData();
			formdata.append("aws_cognito_id", cognito_idp);
			formdata.append("user_name", user.attributes["custom:name"]);
      let url = process.env.VUE_APP_ROOT_API + "get-member-list-for-will";
      if (this.$route.params.type == 'amend') {
        url = process.env.VUE_APP_ROOT_API + "get-completed-wills";
      }
      axios.post(url, formdata).then((response) => {
        let member = [];
        this.response = response.data;
        this.totalMembers = this.response.data.length;
        this.response.data.forEach(member_type_detail => {
          if (this.$route.params.type == 'amend') {
            member.push({value:member_type_detail.member_id,text:member_type_detail.name})
          }
          else {
            member.push({value:member_type_detail.id,text:member_type_detail.name})
          }
        })
        let color = ['skyblue','pink','lightgray']
        this.all_member_list.push({members:member,selectedMember:'',color:color})
        this.count = this.all_member_list.length;
        this.countFor();
			})
    })
  },
  created() {
    this.initialize();
    Auth.currentAuthenticatedUser({
      bypassCache: true,
    })
      .then((user) => {
        this.name = user.attributes["custom:name"];
        this.email = user.attributes["email"];
        this.mobile_no = user.attributes["custom:phonenumber"];
      })
      .catch((err) => {
        this.$router.push({ name: "Login" }).catch(() => {});
      });

  },
  methods: {
    change(){
       if(this.coupon == ''){
             this.discount = 0
        }
    },
    changeReward(){
       if(this.rewardPoint == ''){
         this.use_reward = 0
        }
    },
    initialize() {
      this.item = [];
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      axios
        .post(process.env.VUE_APP_ROOT_API + "will-charges-listing", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          this.item = response.data.data.will_prices;
          this.reward_point = response.data.data.reward_point;
          this.reward_point.forEach(val=>{
            this.reward = val.reward_point;
          })
          this.totalPrice = this.item.find(food => food.will_type === "Single WILL").price_per_will
          this.singleWill = this.item.find(food => food.will_type === "Single WILL").price_per_will
          this.twoWill = this.item.find(food => food.will_type === "Two WILLs").price_per_will
          this.threeWill = this.item.find(food => food.will_type === "Three WILLs").price_per_will
        });
    },
    addMembers(){
      if(this.all_member_list.length < this.totalMembers){
        let member = [];
        let selectedMembers = [];
        this.all_member_list.forEach(member => {
          selectedMembers.push(member.selectedMember)
        })
        this.response.data.forEach(member_type_detail => {
          let id = member_type_detail.id;
          if (this.$route.params.type == 'amend') {
            id = member_type_detail.member_id;
          }
          if(!selectedMembers.includes(id)){
            member.push({text:member_type_detail.name, value:id})
          }
        })
        let color = ['skyblue','pink','lightgray']
        this.all_member_list.push({members:member,selectedMember:'',color:color})
        this.count = this.all_member_list.length;

        // this.all_member_list.forEach(val=>{
        //   this.member_lengthwill_type = val.members.length-1;
        // })
        this.countFor();
      }
      else{
        swal.fire({
          text:'You can not add more than ' +this.count+' members.',
          icon:'warning',
        })
      }
    },
    remove(index){
      if(this.count > 1)
      {
        this.all_member_list.pop(index);
        this.count = this.all_member_list.length;
        this.countFor();
      }
    },
    countFor(){
      if (localStorage.getItem('will_type') == 'amend') {
        this.totalPrice =  500 ;
      }
      else {
        if(this.count == 1) {
          this.totalPrice =  this.singleWill 
        }
        else if(this.count == 2) {
          this.totalPrice =  this.twoWill *2
        }
        else {
          this.totalPrice =  this.threeWill * this.count
        }
      }
    },
    nextPage() {
      let error = 0
      this.all_member_list.forEach((item, index)=>{
        if(item.selectedMember === ''){
          swal.fire({
            title: "Error!",
            text: "Please select Member "+(index+1),
            icon: "error",
            showCancelButton: false,
            confirmButtonColor: "#051d42",
            confirmButtonText: "OK",
          });
          error = 1
        }
      })
      if (!error) {
        this.procced_dialog=true
      }
    },
    afterPayment()
    {
      clearInterval(this.myInterval);
      this.$router.push({ name: 'MemberWillCreation' }).catch(() => {});
    },
    backButton() {
      clearInterval(this.myInterval);
      this.$router.push({ name: 'ValueAddedServices' }).catch(() => {});
    },
    addCoupon(){
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("coupon_code", this.coupon)
      axios
        .post(process.env.VUE_APP_ROOT_API + "will-discount-coupon", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
        if (response.data.status == "success") {
           swal.fire({
              title: "Success!",
              text: "You have got " +response.data.data.deduction_percentage+ "% of discount.",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#051d42",
              confirmButtonText: "OK",
            });
          let percent = response.data.data.deduction_percentage;
          this.discount = this.totalPrice * percent /100;
          } else {
                swal
               .fire({
                 text: " Please enter a valid discount coupon code",
                 icon: "warning",
                 showCancelButton: false,
                 confirmButtonColor: "#051d42",
                confirmButtonText: "OK",
               })
           } 
        });
       
   },
    redeemedPoint(){
      if(this.reward != 0)
      {
          if(this.reward >=this.rewardPoint)
            {
            this.use_reward = this.rewardPoint;
            if(this.use_reward)
            {
            swal.fire({
              title:'Your point is redeemed',
              icon:'success',
              showCancelButton: false,
              confirmButtonColor: "#051d42",
              confirmButtonText: "OK",
            })
            this.totalPoint  = this.reward - this.use_reward;
            // console.log(this.totalPoint);
            }
          }
          else{
            swal.fire({
            title:'You have only '+this.reward+' reward points',
            icon:'warning',
          })
          this.rewardPoint = "";
          }
         
      }
      else{
         swal.fire({
          title:'No Reward Points',
          icon:'warning',
        })
      }
    },
    choosePaymentMethod(payment_type)
    {
      this.$loading(true);
      let selectedM = [];
      this.all_member_list.forEach(val=>{
        selectedM.push(val.selectedMember);
      })
      
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("awsCognitoId", cognito_idp);
      formdata.append("paymentType", payment_type)
      formdata.append("userMobile", this.mobile_no.replace("+", ""));
      formdata.append("userEmail", this.email);
      formdata.append("user_name", this.name)
      formdata.append("use_reward", this.use_reward);
      formdata.append("coupon_code", this.coupon)
      formdata.append("no_of_members", this.count);
      formdata.append("selected_members", JSON.stringify(selectedM));
      formdata.append("will_type", this.$route.params.type);
      axios
        .post(process.env.VUE_APP_ROOT_API + "create-will-payment-link", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          this.$loading(false);
          this.payment_link_info = response.data.data;
          
          let link_url =
            payment_type == "cashfree"
              ? this.payment_link_info.link_url
              : this.payment_link_info.payment_url;
          this.openWindow = window.open(link_url, "", "width=900,height=500");
          this.is_payment_confirmation = true;
          let self = this;
          this.myInterval = setInterval(function () {self.confirmWillPayment()}, 2000);
        });
    },
    confirmWillPayment() {
    // console.log("HIIIIIIIIII");
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let formdata = new FormData();
      formdata.append("awsCognitoId", cognito_idp);
      formdata.append("userMobile",  this.mobile_no.replace("+", ""));
      formdata.append("userEmail", this.email)
      formdata.append("user_name", this.name)
      axios
        .post(process.env.VUE_APP_ROOT_API + "get-will-payment-info", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          this.$loading(false);
          this.payment_link_info = response.data.data;
          if (this.payment_link_info.payment_status == "PAID") {
            clearInterval(this.myInterval);
            this.myInterval = '';
            this.openWindow.close();
            this.$router.push({ path: '/creation/'+this.$route.params.type }).catch(() => {});
            this.$store.getters.getProfileDetail.data.reward_point = response.data.reward_points;
          }
        });
  },
 
  },
  
};
</script>
<style>
.will_container {
  font-size: 18px;
  background: #f1f1f1;
  margin-left: 50px;
  padding: 10px;
  color: #2d2d2d;
}
.payment-one {
  /* background: #0f487f; */
  margin-right: 50px;
  font-size: 18px;
  padding: 10px;
  color: #fff;
}

.charges {
  color: #333333;
  font-size: 16px;
  background: #f2f9ff;
  text-align: center;
  margin: 0px 50px 0px 50px;
  height: 35px;
  padding-top: 5px;
}
</style>
